import React from "react";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
function Header() {
  return (
    <header>
      <h1><HowToVoteIcon  fontSize="large"/> Lottery - Ballot</h1>
    </header>
  );
}

export default Header;
